import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './DatePickerRange.css';

class DatePickerRange extends Component {
  static defaultProps = {
    numberOfMonths: 2
  };
  state = {
    from: undefined,
    to: undefined
  };

  handleDayClick = day => {
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range, () => {
      if (this.state.from && this.state.to) {
        this.props.handleSetRange(range);
      }
    });
  };

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    return (
      <div>
        <DayPicker
          className="Selectable"
          numberOfMonths={this.props.numberOfMonths}
          onDayClick={this.handleDayClick}
          selectedDays={[from, { from, to }]}
          modifiers={modifiers}
        />
      </div>
    );
  }
}

DatePickerRange.propTypes = {
  numberOfMonths: PropTypes.number,
  handleSetRange: PropTypes.func
};

export default DatePickerRange;
